<template>
  <!-- 질문31,32 -->
  <v-layout flex-fill column class="survey-type-08">
    <div class="subheader">가능한 한 빠르게, 생각나는 대로 답변해 주세요.</div>
    <div class="question">가장 먼저 떠오르는 '단어'를 자유롭게 작성해 주세요.</div>
    <div class="answer flex-grow-0">
      <div class="answer-text answer-text-start">
        <div class="box" v-html="question"></div>
      </div>
    </div>
    <div class="answer">
      <v-text-field
          filled
          solo
          flat
          background-color="#F7F7F7"
          placeholder="단어를 작성해주세요."
          :value="value"
          @input="inputChanged"
      ></v-text-field>
    </div>
  </v-layout>
</template>

<script>
import store from '../../store'

export default {
  props: ["question", "surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data: () => ({
    value: '',
    memberNo: 0
  }),
  watch: {
    question() {
      this.getStepLoadData();
    }
  },
  created() {
    this.memberNo = this.$store.state.auth.authUser.userKey;
    this.getStepLoadData();
  },
  methods: {
    inputChanged(input) {
      this.value = input;
      this.$emit('emotionSelected', input);
    },
    async getStepLoadData() { // 스텝별 저장 데이터를 가져옴.
      console.log('Step 08 - getStepLoadData Call');
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.memberNo},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            this.value = res.data.reply;
            this.inputChanged(res.data.reply);
          } else {
            console.log(res.msg)
            this.value = '';
          }
        })
        .catch(error => {
          console.error(error)
          this.value = '';
        })
        .finally(() => {
        })
    },
  }
}
</script>

<style lang="scss" scoped>
//.box {
//  display: inline-flex;
//  justify-content: center;
//  align-items: center;
//  width: 160px;
//  height: 50px;;
//  border-radius: 6px;
//  border: 1px solid #D6D6D6;
//  margin-bottom: 70px;
//}
//
//::v-deep.v-text-field--filled {
//  .v-input__slot {
//    min-height: 50px;
//    padding: 0 20px !important;
//  }
//}
</style>
